import React, {useState, Fragment} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import Image from '../Media/Img/logo-oax-color.png';

import { servicios_grupogack_url, ocurrio_un_error, lengthPassword } from '../Constants/Constants';
import AlertForm from '../Services/AlertForm';
import axios from 'axios';

import {obtenerUsuario, headersAuth} from '../Services/AuthService';
import PasswordInput from '../Services/Validation/PasswordInput';

function AlertPassSession({ openContrasena, setModalContraseña, setTimeout, activarEventosInactividad, closeSession }) {

    const contraseñaRef = React.createRef('');
    const [ error, setError ] = useState( null );
    const [ diss, setDiss ] = useState( false );

    const revalidarSesion = (evt) => {
        evt.preventDefault();
        const password = contraseñaRef.current.value;
        if( password.trim() === '' ){
            setError( <AlertForm className="mt-5" message = {"Ingrese su contraseña o cierra la sesión"} /> );
            return;
        }
        setError( null );
        serviceRefresh( password );
    }

    const logout = async () => {
        await axios.post( `${servicios_grupogack_url}/account/logout`, null, headersAuth() );
    }

    const obtenerRelacioLaboralLS = () => {
        return JSON.parse(localStorage.getItem("IGCompania"));
    };
    const asignarRelacionLabolar=(authToken)=>{
        const relacionLaboralLS = obtenerRelacioLaboralLS();
        if(relacionLaboralLS){
            axios.post( `${servicios_grupogack_url}/asigna/empresa`, {empresa: relacionLaboralLS.id}, {headers : { 
                "X-Authorization": authToken,
                'Content-Type': 'application/json'
            }})
                .then(res => {
                    switch(res.data.status){
                        case 200:
                            localStorage.setItem( "IGCompania", JSON.stringify(relacionLaboralLS));
                            break;
                        default:
                            setError( <AlertForm message={ ocurrio_un_error } /> );
                            break;
                    }
                })
                .catch( error => {
                    setError( <AlertForm message={ ocurrio_un_error } /> )
            });
        }
        
    }

    const serviceRefresh = async ( password ) => {
        setDiss( true );
        logout();

        const usuario = obtenerUsuario();
        const data = { username: usuario.usuario, password };
        try {
            const respuesta = await axios.post( `${servicios_grupogack_url}/account/login`, data );
            const authToken = respuesta.headers[ "x-authorization" ];
            if( authToken ) {
                asignarRelacionLabolar(authToken);
                const { id, nombre, paterno, materno, username, tour, tyc } = respuesta.data.dataResponse;
                localStorage.setItem( "IGSESSID", JSON.stringify( { "token": authToken, "claveUsuario": id, "nombre" : nombre, "apaterno": paterno, "amaterno": materno, "usuario": username, "tour": tour, "tyc": tyc }));
                setDiss( false );

                localStorage.setItem("revalidateSession", JSON.stringify( { revalidate: false } ));
                setModalContraseña(false); //Cerrar Modal RecuperaSession
                setTimeout();
                activarEventosInactividad( true );
            } else {
                const msg = respuesta.data.msg;
                console.log("Mensaje: "+msg);
                if( msg ) {
                    setError( <AlertForm message={ msg } /> );
                } else {
                    setError( <AlertForm message={ ocurrio_un_error } /> );
                }
                setDiss( false );
            }
        } catch (error) {
            setDiss( false );
            setError( <AlertForm message="Existe una sesión activa"/> );
        }
    }

    return (
        <Fragment>
            <style>
                {`
                    .cont_log {
                        z-index: 15001 !important;
                    }
                `}
            </style>
            <Dialog open={openContrasena} aria-labelledby="alert-dialog-title" className="cont_log">
                <DialogContent>
                <div className = "title">
                            <img src="/images/logo.png"className="header_logo" style={{width: "30%"}} alt="site-logo"/>
                            <span>Tiempo de inactividad superado</span>
                    </div>
                    <form onSubmit={ revalidarSesion }>
                            <label>Contraseña</label>
                            <input type="password" className="form-control mb-3" placeholder="Contraseña" maxLength={lengthPassword}
                                ref={ contraseñaRef }/>
                            { error }
                            <Button className="btn-color" type="submit" disabled={ diss }>Recuperar Sesión</Button>
                            <Button className="btn-outline" onClick={ closeSession } disabled={ diss }>Cerrar Sesión</Button> 
                    </form>
                </DialogContent>
            </Dialog>
        </Fragment>
    );
}
export default  AlertPassSession;